import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { BrandingService } from '../../../../../common/branding/branding.service';
import { wordmarkFontSize } from '../../../../../common/branding/brand-wordmark';

@Component({
  selector: 'mars-join-suppliers-network',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './join-suppliers-network.component.html',
  styleUrl: './join-suppliers-network.component.scss',
})
export class JoinSuppliersNetworkComponent {
  /** The replica's name, or the default brand's when it set none. */
  protected readonly brandName = inject(BrandingService).name;
  protected readonly fontSize = wordmarkFontSize;
}
